/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { Loader } from 'src/components';
import styles from './Desktop.module.css';
import { CandidateInfoViewRendererProps } from '../../types';
import { CandidateInformationForm } from '../../components';

function Desktop(props: CandidateInfoViewRendererProps) {
  const {
    profileInfo,
    loading,
    payTypes,
    resumeSources,
    workAuthorizations,
    loadingFailed,
    updateProfileInfo,
    updatingForm,
  } = props;

  if (loading) {
    return (
      <div className="fixed top-[50vh] left-[50vw]">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div className={styles.root}>
        <CandidateInformationForm
          profileInfo={profileInfo}
          payTypes={payTypes}
          resumeSources={resumeSources}
          workAuthorizations={workAuthorizations}
          loadingFailed={loadingFailed}
          updateProfileInfo={updateProfileInfo}
        />
      </div>
      {(updatingForm) && (
        <div className="fixed top-[50vh] left-[50vw]">
          <Loader text="Updating ..." />
        </div>
      )}
    </>
  );
}

export default Desktop;
